<template>
  <div class="home">
    <template v-if="!loading">
      <Navigator :active="activeIndex" @update:active="gotoSection" />
      <Header @gotoSection="gotoSection" @click.native="handleClick" />
      <Summary @ready="onReady" />
      <course @ready="onReady" />
      <student @ready="onReady" />
      <activity @ready="onReady" />
      <apply @ready="onReady" />
      <contact @ready="onReady" />
      <Footer />
      <img v-show="activeIndex" class="goto-top" :src="images.top" @click="gotoTop">
      <!-- return home -->
      <div class="returnHome"><a href="https://wx.ceibs.edu/HtmlApps/html/special/navigation/index.html"><img
            :src="images.iconHome" alt=""></a></div>
    </template>
    <div v-else class="loading">
      <img :src="images.loading" alt="" class="loading-img" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/header.vue'
import Summary from '@/components/summary.vue'
import Course from '@/components/course.vue'
import Student from '@/components/student.vue'
import Activity from '@/components/activity.vue'
import Apply from '@/components/apply.vue'
import Contact from '@/components/contact.vue'
import Footer from '@/components/footer.vue'
import Navigator from '@/components/navigator.vue'
import images from '@/utils/images.js'
import Preload from '../preload.js';

const cubic = value => Math.pow(value, 3);
const easeInOutCubic = value => value < 0.5
  ? cubic(value * 2) / 2
  : 1 - cubic((1 - value) * 2) / 2;
const sections = ['summary-section', 'course-section', 'student-section', 'activity-section', 'apply-section', 'contact-section']
export default {
  name: 'Home',
  components: {
    Footer,
    Contact,
    Apply,
    Activity,
    Student,
    Summary,
    Header,
    Navigator,
    Course
  },
  data () {
    return {
      activeIndex: 0,
      loading: true,
      images: images,
      count: 0,
      offsetTops: []
    }
  },
  // mounted() {
  //   if (this.$route.query.active) {
  //     setTimeout(()=>{
  //       this.activeIndex = +(this.$route.query.active || 0)
  //     }, 200)
  //   }
  // },
  watch: {
    loading (newVal) {
      if (!newVal) {
        if (this.$route.query.active) {
          setTimeout(()=>{
            this.activeIndex = +(this.$route.query.active || 0)
          }, 200)
        }
      }
    }
  },
  created () {
    // 使用preload来加载图片
    const pics = []
    for(const key in images) {
      pics.push(images[key])
    }
    new Preload(pics, {
      complete: (a, b, errors) => {
        this.loading = false;
        console.log('成功:', a, ', 失败:', b);
        console.log('错误列表:', errors);
        window.t = function() {
          console.log('成功:', a, ', 失败:', b);
          console.log('错误列表:', errors);
        }
      }
    })

    window.l = () => {
      this.loading = true;
      new Preload(pics, {
        complete: (a, b, errors) => {
          this.loading = false;
          console.log('成功:', a, ', 失败:', b);
          console.log('错误列表:', errors);
          window.t = function() {
            console.log('成功:', a, ', 失败:', b);
            console.log('错误列表:', errors);
          }
        }
      })
    };
    // 加个补偿，如果20秒后不成功，自动消失loading
    setTimeout(() => {
      this.loading = false
    }, 20000)
  },
  mounted() {
    window.home = this;
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      if (this.cancelScroll) {
        return;
      }
      let scrollY = window.scrollY
      // let offsetTop = this.$refs.self.offsetTop
      // console.log(this.index, '--', 'scrollY:', scrollY, ',offset:', offsetTop);
      // // 滚动条在当前元素上方100像素内，认为激活
      // if (scrollY > offsetTop - 100 && scrollY < offsetTop) {
      //   this.$emit('active', this.index);
      // }
      // if (scrollY < offsetTop - 100 && scrollY > offsetTop - 200) {
      //   this.$emit('inactive', this.index);
      // }
      let activeIndex = 0;
      for(let i = 0; i < this.offsetTops.length; i++) {
        const offsetTop = this.offsetTops[i];
        const nextOffsetTop = this.offsetTops[i + 1];
        if (scrollY > offsetTop - 100 && (nextOffsetTop && scrollY < nextOffsetTop - 100 || !nextOffsetTop)) {
          activeIndex = i + 1;
          break;
        }
      }
      // console.log(activeIndex, ' ', scrollY, this.offsetTops)
      this.activeIndex = activeIndex
    },
    onReady(index, offsetTop) {
      this.offsetTops[index - 1] = offsetTop;
    },
    handleClick() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = undefined;
      }
      this.timer = setTimeout(() => {
        this.count = 0;
      }, 3000);
      this.count++;
      if (this.count > 10) {
        // 调出vconsole
        const scriptDom = document.createElement('script');
        scriptDom.src = './vconsole.min.js';
        document.body.appendChild(scriptDom);
        scriptDom.onload = function() {
          new window.VConsole();
        }
      }
    },
    gotoSection(index) {
      if (this.cancelScroll) {
        return;
      }
      this.cancelScroll = true;
      // 跳转到指定的section
      // const sections = ['', 'summary-section', 'course-section', 'student-section', 'activity-section', 'apply-section', 'contact-section']
      const name = sections[index - 1]
      if (name) {
        const ele = document.querySelector('.' + name)
        const fontSize = parseInt(document.documentElement.style.fontSize) || 1;
        const top = ele.offsetTop - 2.4 * fontSize
        // document.documentElement.scrollTop = top
        // document.body.scrollTop = top
        const el = document.documentElement;
        const beginTime = Date.now();
        const beginValue = el.scrollTop;
        const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
        const frameFunc = () => {
          const progress = (Date.now() - beginTime) / 500;
          if (progress < 1) {
            el.scrollTop = top + (beginValue - top) * (1 - easeInOutCubic(progress));
            rAF(frameFunc);
          } else {
            el.scrollTop = top;
            if (this.timeout) {
              clearTimeout(this.timeout);
              this.timeout = undefined;
            }
            this.timeout = setTimeout(() => {
              this.timeout = undefined;
              this.cancelScroll = false;
            }, 50);
          }
        };
        rAF(frameFunc);
      }
      this.activeIndex = index
    },
    gotoTop() {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      this.activeIndex = 0
    },
    /**
     * 重新生成各个区块的顶部位置
     * 在区块高度变化时需要
     */
    getOffsetTops() {
      console.log(sections);
      sections.forEach((item, i) => {
        const ele = document.querySelector('.' + item);
        if (ele) {
          this.offsetTops[i] = ele.offsetTop;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 200px;
  }
}
.goto-top {
  position: fixed;
  bottom: 150px;
  right: 0;
  width: 80px;
  z-index: 20;
}
.returnHome {
  width: 1.06666667rem;
	position: fixed;
	top: 20%;
	right: 0;
	z-index: 3;
}
</style>